import React from "react";
import "./VideoSticker.css";

function VideoSticker({ 
  imageSrc, 
  imageAlt = "Sticker",
  linkUrl,
  linkTitle = ""
}) {
  return (
    <div className="video-sticker">
      <a 
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="video-sticker-link"
        title={linkTitle}
      >
        <img 
          src={imageSrc}
          alt={imageAlt}
          className="video-sticker-image"
        />
      </a>
    </div>
  );
}

export default VideoSticker;

